export const stage = import.meta.env.VITE_STAGE as string ?? null
export const releaseVersion = import.meta.env.VITE_RELEASE_VERSION as string ?? null
